/*
 * For use in array filters where you want to preserve the type information
 * of the non-undefined array items.
 */
export default function notUndefined<T>(item: T | undefined): item is T {
    return item !== undefined;
}
